export default "__VITE_ASSET__DyGiEVdT__"